export default {
  Tips_Common: {
    non_system_interface: '非本系统的接口',
    bad_request: '请求错误',
    relogin: '请重新登录',
    request_404: '请求地址404',
    request_timeout: '请求超时',
    system_unavailable: 'The system is temporarily unavailable. Please try again later or contact staff.',
    login_invalid: '登陆信息已失效，请重新登录',
    account_other_login: '账号在其他地方登录',
    unknown_error: '未知错误',
    // err_network: '网络异常，请检查网络连接',
    request_error: '请求失败',
    Changes_Clinic_Settings: 'Save changes to clinic treatment settings?',
    Cntrols_Successfully: 'Successful operation',
    Input_Promotion_Name: 'Input Name',
    Input_Promotion_Code: 'Input Code',
    select_yishi: 'Please select a medic',
    select_shouquan_yishi: 'Please select an authorized medic',
    shouquan_same_yishi: 'The authorized medic cannot be the same as the medic',
    shouquan_example_tip: '* Example: Dr. Li (Medic) — Dr. Yang (Authorized Medic)',
    reset_successfully: 'Reset successfully',
    edit_successfully: 'Modified successfully',
    add_successfully: 'Add successfully',
    complete_certificate: 'Complete the certificate list',
    has_confirm_shutdown: 'Data has been modified. Confirm shutdown?',
    enter_account: 'Enter account',
    must_account_less: 'Account cannot be less than 6',
    must_account_than: 'Account cannot exceed 20',
    must_account_fomat: 'Contain Uppercase, Lowercase, Number, Special characters(_-@.)',
    format_error: 'Input format error',
    enter_id: 'Enter your ID number',
    must_id_less: 'ID number must be at least 6 characters',
    perfect_source: 'Complete source',
    file_format_incorrect: 'Please upload the file in jpeg, png or pdf format',
    enter_name: 'Enter name',
    enter_phone: 'Enter phone',
    select_birth: 'Select birth',
    select_doctor_category: 'Select doctor category',
    select_sex: 'Select sex',
    select_scheduling: 'Select scheduling',
    enter_describe: 'Enter describe',
    select_cert_type: 'Select type',
    enter_certificate_numb: 'Enter number',
    enter_certificate_title: 'Enter title',
    select_issue_date: 'Select issue date',
    upload_attachment: 'Upload the attachment',
    search_menu: 'Search Menu',
    full_screen: 'Full screen',
    full_screen_out: 'Exit full screen',
    content_recovery: 'Content recovery',
    content_enlargement: 'Content enlargement',
    content_full_screen: 'Content full screen',
    deleting_role: 'Deleting a role',
    confirm_deletion: 'Confirm deletion',
    del_successfully: 'Delete successfully',
    input_bag_time: 'Input',
    input_g_bag: 'Input',
    bag_time_need: 'non-zero',
    g_bag_need: 'non-zero',
    method_need: 'Select at least one method',
    postage_need: 'Enter the postage',
    cannot_null: 'Cannot be null!',
    end_equal_start: 'End of the scale setting must be equal to the start of the next stage!',
    config_save_no: 'Save or not?',
    config_save_no_logout: 'Save or not? Logout after saving',
    save_successfully: 'Save successfully',
    err_network: 'Err Network',
    loading: 'Loading',
    discount_example: '80% = 20% off',
    denomination_need: 'Enter denomination',
    discount_need: 'Enter discount',
    enter_coupon_name: 'Enter coupon name',
    enter_setmeal_name: 'Enter setmeal name',
    select_is_coupon: 'Select subscriber or not',
    select_coupon_type: 'Select coupon type',
    select_is_enable: 'Select enable or not',
    enter_amount: 'Enter amount',
    select_scope_use: 'Select scope use',
    denomination_less_amount: 'Denomination must be less than full deduction',
    min_warning_less_max: 'Minimum warning quantity must be less than maximum warning quantity',
    sliding_expiry_hint: 'Expires {duration}{unit} after issuance',
    taopiao_sliding_expiry_hint: 'Expires {duration}{unit} after purchase',
    enter_expiration_duration: 'Please enter the validity duration',
    expiration_duration_range: 'Validity duration must be between 1 and {max} {unit} (10 years max)',
    select_expiration_time: 'Please select expiration time',
    expiration_time_before_sale_end: 'Fixed expiration date cannot be earlier than the sale end date',
    expiration_time_before_today: 'Fixed expiration date cannot be earlier than today',
    end_time_before_start_time: 'End time cannot be earlier than start time',
    select_expiration_type: 'Please select expiration type',
    deleting_project: 'Deleting a coupon',
    attachment_load: 'Attachment uploaded, please wait',
    information_backfill: 'The current ID number has user information, whether to backfill',
    cannot_activated: 'The drug has been disabled by the platform and cannot be operated',
    select_address: 'Select address information',
    tips_address: 'Length should be 2-120, and cannot contain emoticons',
    use_default: 'Confirm whether to use the default address',
    enter_pingyin: 'Enter Chinese or Pinyin',
    enter_code: 'Enter code',
    enter_price: 'Enter price',
    enter_min_whole: 'Enter minimum warning quantity',
    enter_max_whole: 'Enter maximum warning quantity',
    complete_order: 'Complete the current order?',
    order_completed: 'Order completed',
    cancel_successfully: 'Cancel successfully',
    no_record: 'No record of receipt',
    no_data: 'No data',
    enter_opinion: 'Enter opinion',
    audit_completed: 'Audit completed',
    enter_description: 'Enter project description',
    cannot_empty: 'Order cannot be empty',
    submit_successfully: 'Submit successfully',
    clear_order_list: 'Confirm to clear the order list',
    temporary_successfully: 'Temporary successfully',
    bring_quantity: 'Bring in the order quantity',
    least_one_drug: 'Sign for at least one drug',
    confirm_receipt: 'Confirm the receipt of the order',
    continue_sign: 'Signatures is 0, whether to continue to sign',
    sign_successfully: 'Sign successfully',
    expired_continue_sign: 'Drug has expired, continue to sign for it?',
    sign_remaining_all: 'Sign for all remaining order quantity',
    invalid_barcode: 'Invalid code',
    not_onpurchase: 'Drugs are not on the purchase list',
    signings_not_exceed: 'Signings must not exceed the order data',
    whether_backfill: 'ID number has user information, whether to backfill',
    enter_prepaid_name: 'Enter name',
    select_level: 'Select level',
    enter_discount: 'Enter discount',
    enter_discount_zero: 'Discount no zero',
    enter_threshold: 'Enter threshold',
    deleting_card: 'Deleting',
    level_exists: 'Level already exists',
    starting_exists: 'Starting amount already exists',
    confirm_report: 'Confirm report',
    cntrols_successfully: 'Successful operation',
    no_standard: 'No standard',
    sign_first: 'Sign first',
    report_first: 'Report successfully',
    be_un_inequality: 'New passwords do not match',
    KeKong_BuXiuGai: 'Leave blank to keep unchanged',
    password_length_max: 'Password cannot exceed 16 characters',
    confirm_delete_group:
      'Deleting the current group will also delete the associated charging rules and charge items. Are you sure you want to delete',
    confirm_delete_rule:
      'Deleting the current rule will also delete the associated charge items. Are you sure you want to delete',
    set_default: 'Confirm whether to use the default',
    use_price: 'The selling price of the drug is charged',
    use_cost: 'The cost of using the drug is charged',
    use_ticket: 'The selling price of the ticket is charged',
    use_fee: "Use the doctor's fee",
    edit_print: 'Print configuration is being edited. Save changes',
    pay_modify: 'Preset mode locks fee information',
    enter: 'Enter',
    sku_exists: 'The medicine already exists',
    complete_dosage: 'Please complete the dosage of the medicine',
    acupoint_exists: 'Already exists',
    drug_detail: 'Details (Herb)',
    confirm_syncing: 'Confirm syncing drug information to the current product',
    empty_no: ' is null',
    prefix_repeat: 'Prefix repeat',
    un_down_data: 'No data is currently available for download',
    complete_rule: 'Complete rule!',
    input_name_code: 'Input name or code',
    input_name_code_phone: 'Input I.D. No. name or phone',
    input_code_name_phone: 'Input I.D. No. name or phone',
    input_name_en: 'Input name in Chinese or English',
    birthday_out: 'The date of birth cannot be later than today',
    electronic_empty: 'The electronic scale setting value cannot be empty',
    start_next: 'The end value of the electronic scale setting must equal the start value of the next stage',
    input_type: 'Input name',
    source_get_tips1: '* A new number source will be generated. Please confirm whether to overwrite the existing one.',
    source_get_tips2: 'Overwritten: Generation will start from the following day.',
    source_get_tips3: 'Not overwritten: Generation will start from the day after the last number source was created.',
    no_chinese_id: 'No Chinese characters in ID number.',
    no_chinese: 'No Chinese characters allowed.',
    complete_certificate_list: 'Please complete the certificate list!',
    openTime_closeTime_no: 'Business hours cannot be empty!',
    openTime_closeTime_before: 'Closing time must be after opening time!',
    openTime_pre_closeTime_after: 'Start time must be after the end time of the previous period!',
    days_cannot_empty: 'Days cannot be empty.',
    frequency_cannot_empty: 'Daily frequency cannot be empty.',
    confirm_delete: 'Delete?',
    QueRen_BaoCun: 'Save?',
    QueRen_YanQi: 'Confirm postpone?',
    QueRen_She_YouXiaoQi: 'Confirm set validity?',
    QueRen_YanQi_Zhi: 'Confirm postpone to {date}?',
    QueRen_She_YouXiaoQi_Zhi: 'Confirm set validity to {date}?',
    ChuFang_ChaoGuo: 'Prescription count exceeds two, continue applying?',
    TuPian_Jpg_Png: 'Images must be in JPEG or PNG format!',
    TuPian_Size_2MB: 'Image size must be less than 2MB!',
    TuPian_Size_5MB: 'Image size must be less than 5MB!',
    FuJian_Size_10MB: 'Attachment size must be less than 10MB!',
    HaoYuan_save_no: 'Modifying the slot source settings, save?',
    ChaoJi_GuanLiYuan_Ming: 'Super administrator cannot be used as a role name!',
    apply_last_scheduling: 'Previous scheduling data detected. Apply it?',
    interval_save_no:
      'Modifying the slot source settings will clear all scheduling data in the clinic and the existing scheduling rules. Continue?',
    source_day_max: 'The number of source days cannot exceed 720 days',
    interval_changed: 'The interval has changed, which will clear the scheduling rules and generated slots!',
    no_set_ratio: 'No Ratio',
    use_precious: 'The selling price of the drug is precious!',
    effective_upon_next_login: 'Modified successfully, effective upon next login.',
    delete_successfully: 'Delete successfully',
    start_time_cannot_be_after_end_time: 'Start time cannot be after end time',
    cannot_delete_use: 'Cannot delete, already in use',
    cannot_delete: 'Cannot delete',
    cannot_delete_reservation: 'Cannot delete, reservation exists',
    select_clinic: 'Please select clinic',
    select_change_time: 'Please select change time',
    hebing_tuijian_tip:
      'Pick a quick filter (Phone/Name/ID No) or enter a keyword to search, then select patients to merge.',
    // ===== Simplified-Chinese migration: hard-coded prompts collected (2026-09-23) =====
    QueRen_KaiYong: 'Confirm enable?',
    QueRen_TingYong: 'Confirm disable?',
    QueRen_KaiYong_PaiBan: 'Confirm enable scheduling?',
    QueRen_TingYong_PaiBan: 'Confirm disable scheduling?',
    QueRen_ShanChu_JiaoSe: 'Confirm delete {name}?',
    QueRen_ShanChu_CaiDan: 'Confirm delete {name}?',
    QueRen_ShanChu_XiangMu: 'Confirm delete {name}?',
    QueRen_ShanChu_TaoPiao: 'Confirm delete {name}?',
    QueRen_ShanChu_YouHuiQuan: 'Confirm delete {name}?',
    QueRen_ShanChu_HuoDong: 'Confirm delete {name}?',
    QueRen_ShanChu_HuanZhe: 'Confirm delete {name}?',
    QueRen_ShanChu_TiaoZheng: 'Confirm delete?',
    QueRen_ShanChu_CaiGouDan: 'Confirm delete?',
    QueRen_ShanChu_PanDian: 'Confirm delete?',
    QueRen_ShanChu_PiCi: 'Confirm delete?',
    QueRen_ShanChu_ZhuanJieMa: 'Confirm delete {name}?',
    ZhengZai_ShanChu_ShouQuan: 'Delete the authorization of [{staff}] to [{toStaff}]?',
    ZhengZai_ShanChu_ShouQuan_HuanZhe: 'Delete the authorization of patient [{patient}] to [{toStaff}]?',
    QueRen_QuXiao: 'Confirm cancel order {orderNo}?',
    QueRen_QuXiao_CaiGouDan: 'Confirm cancel order {orderNo}?',
    QingXuanZe_YingYeDiDian: 'Please select the clinic!',
    QingWanShan_YaoPinGuiGe: 'Please complete the drug specification information!',
    QingWanShan_ChengFenYao: 'Please complete the ingredient list!',
    QingWanShan_MingGuiYao: 'Please complete the additional fee information for the expensive medicine!',
    QingWanShan_GuiZeLieBiao: 'Please complete the rule list for {types}!',
    QingBuQuan_ShiYongCiShu: 'Please complete the usage times or discount amount limit, and they cannot be zero!',
    TaoPiao_XiangMu_WeiKong: 'Package items cannot be empty!',
    QingXuanZe_YaoPin: 'Select Medicine!',
    QingXuanZe_ShangPin: 'Please select a product!',
    CunZai_WuXiao_YaoPin: 'Invalid medicines exist; cannot be saved!',
    QingXuanZe_FaFang_KeHu: 'Please select the customers to whom coupons will be issued!',
    QingShuRu_FaFangShuLiang: 'Please enter the number of coupons to issue per customer:',
    ZhengZai_FaFang_YouHuiQuan: 'Issuing coupon: {name}',
    QueRen_FaFang_QuanBu: 'Issuing coupon: {name}, {quantity} per customer, confirm distribution to all customers?',
    QueRen_FaFang: 'Issuing coupon: {name}, {quantity} per customer, confirm distribution?',
    YaoPin_YiGuoQi: 'Drug has expired, continue to add?',
    Deng_YaoPin: ' ',
    ChengBenJia_WeiKong: ' cost price cannot be zero or empty',
    XiaDanShuLiang_WeiKong: ' quantity cannot be zero or empty',
    QingXuanZe_ShiJianFanWei: 'Please select a time range',
    KaiShi_BuNeng_DaYu_JieShu: 'Start time cannot be later than end time',
    BuNeng_ChaXun_ChaoYiNian: 'Cannot query a period longer than one year',
    QingXuanZe_ShiJian: 'Please select time',
    ChuCun_ShiBai: 'Save failed',
    ShengCheng_HaoYuan_Tip: 'Generate appointment slots for this doctor now?',
    ShengCheng_HaoYuan_Last: 'Generate slots using this doctor’s last saved schedule. Continue?',
    QingKong_HaoYuan_Tip:
      'This operation will clear all previously configured appointment slots for this doctor at this clinic. Do you want to continue?',
    MeiJie_QieHuan_Tip: 'Switching section time to {minutes} minutes will automatically adjust slot times. Continue?',
    QingShuRu_HaoYuanTianShu: 'Please enter the number of days for slot generation!',
    ZuBie_WeiKong: 'Group setting value cannot be empty',
    ZuBie_JieShu_BuPiPei: 'Group setting end value must equal the start value of the next stage',
    ZhongXinDengLu_ShengXiao: 'Changes take effect after re-login. Confirm?',
    TingYong_WuFa_HuiFu: 'Once disabled, it cannot be enabled again. Confirm?',
    MiMa_BuYiZhi: 'The new passwords entered twice do not match!',
    XinMiMa_Tong_JiuMiMa: 'The new password cannot be the same as the old password!',
    YingYeShiJian_WeiKong: 'Business hours must be set for each week!',
    YingYeShiJian_ChenFu: 'Business hours must be unique!',
    ChongJian_SuoYin_Tip:
      'This will clear and rebuild the patient index. Patient info may be affected until the rebuild completes. Confirm?',
    ChangDu_7_Zhi_11: 'Length must be 7 to 11 characters',
    Tian: ' days',
    Yue: ' months',
    Nian: ' years',
    Yuan: '',
    ChaoGuo: 'More than',
    Mei: 'each',
    JiangShouFei: ' will charge',
    An_ZhongLiang_JiFei: 'Weight',
    An_ChengBen_JiFei: 'Cost',
    An_WeiShu_JiFei: 'Quantity',
    BingZhengZhi: 'Disa-Synd-Trea',
    GongKai_SiYou_Tip: 'Public - Visible to anyone in the clinic',
    SiMi_SiYou_Tip: 'Private - Only you can view',
    QingXianShuRu_BingMing: 'Enter disease first',
    QingXianShuRu_ZhengXing: 'Enter disease first',
    RenShen: 'Pregnancy',
    JinZhi_Label: 'Forbid',
    JingGao_Label: 'Warn',
    ZhiBiao: 'Indicator',
    LiShi_PaiBan: 'History',
    ZanWu_LiShi_PaiBan: 'No historical scheduling data available',
    QuanBu_Label: 'All',
    GuiShu_Label: 'Assigned',
    Zhou_Label: '',
    FenChai_Dian: 'Split Point',
    XuanZe_GuanLiYuan: 'Select Manager Staff',
    ShuRu_XingMing_DianHua: 'Input Name Phone',
    YouHuiQuan_FaFang_Title: 'Coupon Issuance',
    KuCun_TiaoZheng_Title: 'Inventory Adjustment',
    JianYi_CaiGouLiang: 'Recommend',
    QieHuan_Label: 'Switch',
    GuanBi_Label: 'Close',
    Gong_N_Xiang: 'Total {total} items',
    SouSuo_CaiDan: 'Search menu',
    SouSuo_JieGuo: 'Search results',
    WuFa_JinRu_CaiDan: 'Cannot open this menu via search. Set a unique Name for the corresponding route',
    CaiDan_BiXu_CanShu: 'This menu has required dynamic params and cannot be opened via search',
    LiuLanQi_WuFa_GongZuo: 'Your browser does not work',
    YunXu_XinChuangKou: 'Please allow the browser to open new windows!',
    QuanPing_Label: 'Full screen',
    TuiChu_QuanPing: 'Exit full screen',
    BuJu_PeiZhi: 'Layout config',
    GongNeng_PeiZhi: 'Feature config',
    ChongZhi_Label: 'Reset',
    XianShi_Logo: 'Show Logo',
    GuDing_Header: 'Fixed Header',
    XianShi_YeJiao: 'Show Footer',
    ZuoCe_MoShi: 'Side mode',
    DingBu_MoShi: 'Top mode',
    HunHe_MoShi: 'Mixed mode',
    DiTu_JiaZai_ShiBai: 'Map failed to load, please check the AMap key config',
    GaoDe_Key_WuXiao:
      'AMap key invalid or geocoding service not authorized. Check the key config and enable the security key',
    DiLiBianMa_ShiBai: 'Geocoding failed: {info}',
    QingShuRu_DiZhi: 'Please enter an address',
    DiTu_WeiChuShiHua: 'Map service not initialized, please try again later',
    WeiZhaoDao_DiZhi: 'Address not found: {keyword}',
    QingXuanZe_DiDian: 'Please select a location first',
    LuYouShouWei_CuoWu: 'Router guard error',
    ZhiYeXuKeZheng_ZhengBen: 'Medical institution practice license (original)',
    ZhiYeXuKeZheng_FuBen: 'Practice license (duplicate)',
    ZhiYeXuKeZheng_NianJian: 'Practice license duplicate latest annual inspection page',
    MinZhengJu_BeiAn: 'Civil Affairs Bureau filing',
    YingYeZhiZhao: 'Business license',
    ZuZhi_JiGouDaiMa: 'Organization code certificate',
    ShuiWu_DengJiZheng: 'Tax registration certificate',
    FangShe_ZhenLiaoXuKe: 'Radiotherapy practice license',
    FangShe_AnQuanXuKe: 'Radiation safety license',
    XianJin_E_Song: 'Amount (Bonus)',
    Yuan_E_Song: 'Original amount (Bonus)',
    LaiYuan_Label: 'Source',
    ZhenSuo_MaoHao: 'Clinic: ',
    FaFangShuLiang_CuoWu: 'The quantity must be a non-zero integer between 1 and 5',
    FaFang_HaoShi_Tip: 'Issuing all will take a while, please wait...',
    FaFang_HouTai_Tip: 'Background is still issuing, please refresh the page later to check',
    TiaoMa_ErWeiMa_WeiKong: 'Barcode and QR code cannot both be empty!',
    QueRen_GengXin_YaoPin: 'Confirm to update all current drug information?',
    JiaoSe_XinXi_ShiBai: 'Failed to get role info',
    QuanXian_BaoCun_ChengGong: 'Role permissions saved successfully',
    QuanXian_BaoCun_ShiBai: 'Failed to save role permissions',
    ChongJian_SuoYin_Label: 'Rebuild Index',
    HeBing_QueRen_Tip:
      'The medical records and visit info of the following {count} patients will be merged into primary patient 【{name}】: {list}. These patient profiles will be deleted after the merge and cannot be restored. Confirm merge?',
    Zan_Wu_SouSuo_JieGuo: 'No search results',
    QingShuRu_HuoDong_JiaGe: 'Please enter the promotional price for each item (0 is allowed, but it cannot be blank)',
    QingShuRu_HuoDong_ZheKou:
      'Please enter the promotional discount for each item (must be greater than 0, and cannot be blank)',
    HuoDong_ZheKou_BuKe_Wei_Ling: 'The promotional discount cannot be 0',
  },
}
